import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ModalComp } from "../../PO/Modal/ModalComp";
import { BillsAttachments } from "../BillsAttachments/BillsAttachments";
import { BillsNotes } from "../BillsNotes/BillsNotes";
import { BillsPaymentDetailCard } from "../BillsPaymantDetailCard/BillsPaymentDetailCard";
import styles from "./billsPaymentDetails.module.css";
import { IMAGE_PATH } from "../../../Utils/variables";
import { Tooltip, Paragraph, TextInput } from "evergreen-ui";
import StatusBadge from "../../Common/StatusBadge";
import { PurchaseOrderTable } from "../../PO/PurchaseOrderTable/PurchaseOrderTable";
import CustomDeleteConfirmationModal, {
  DeleteConfirmationSideSheet,
} from "../../Common/CustomeDeleteConfirmationModal";
import { toast } from "react-toastify";
import { loadData } from "../../../Utils/localStorage";
import CustomButton from "../../Common/CustomButton";

export const BillsPaymentDetails = ({
  detailId = "",
  communityId = "",
  isNormalBill,
  getFilterData,
  deleteBill,
  isDeleting,
  openDeleteModal,
  setOpenDeleteModal,
}) => {
  const filePickerRef = useRef(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [detail, setDetail] = useState("");
  const [showMessages, setShowMessages] = useState(false);
  const [comment, setComment] = useState("");
  const [total, setTotal] = useState(0);
  const [initialLoading, setinitialLoading] = useState(true);
  const vendorId = JSON.parse(localStorage.getItem("vendorId"));
  const [billLogs, setBillLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [documentUploading, setDocumentUploading] = useState(false);

  const [documents, setDocuments] = useState([]);
  const logsRef = useRef(null);

  const MAX_FILE_SIZE_MB = "25";

  useEffect(() => {
    const abortController = new AbortController();
    if (detailId && communityId) {
      setinitialLoading(true);
      fetch(
        process.env.REACT_APP_API_URL + "/api/vendorpo/vendorBillsDetailbyID",
        {
          method: "POST",
          body: JSON.stringify({
            bill_id: detailId,
            community_id: communityId,
            is_normal_bill: isNormalBill ? 1 : 0,
          }),
          headers: { "content-type": "application/json" },
          signal: abortController.signal,
        }
      )
        .then((response) => response.json())
        .then((result) => {
          const data = result.response.data;
          if (detailId == data?.bill_id) {
            setinitialLoading(false);
          }
          if (data.length == 0) {
            toast.error(result.response.message);
            setinitialLoading(false);
          }
          const itemsArr = data?.vendor_bill_items;
          const sum = itemsArr?.reduce((accumulator, e) => {
            return accumulator + parseFloat(e.total_amount);
          }, 0);
          setTotal(sum);
          setDetail(data);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setDetail("");
      setinitialLoading(false);
    }
    return () => {
      abortController.abort();
    };
  }, [detailId, communityId, isNormalBill]);

  useEffect(() => {
    if (detailId && communityId) {
      setShowMessages(false);
      setBillLogs([]);
    }
  }, [detailId, communityId]);

  const getVendorBillLogs = () => {
    fetch(process.env.REACT_APP_API_URL + "/api/vendorpo/getVendorBillsLogs", {
      method: "POST",
      body: JSON.stringify({
        bill_id: detailId,
        community_id: communityId,
        vendor_id: vendorId,
        is_normal_bill: isNormalBill ? 1 : 0,
      }),
      headers: { "content-type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        const logs = result?.response?.data?.bills_logs;
        setBillLogs(logs?.reverse());
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function BillNotification({ message }) {
    return <div dangerouslySetInnerHTML={{ __html: message }} />;
  }

  const bytesToKB = (bytes) => {
    return (bytes / 1024).toFixed(2) + " KB";
  };

  const handleIconClick = () => {
    if (filePickerRef.current) {
      filePickerRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    toast.dismiss();
    const file = Array.from(event.target.files);

    let filesSize = 0;
    for (let i = 0; i < file.length; i++) {
      filesSize = filesSize + file[i].size;
    }

    if (filesSize > MAX_FILE_SIZE_MB * 1024 * 1024) {
      toast.error(
        `File size exceeds the maximum limit of ${MAX_FILE_SIZE_MB} MB.`
      );
      return;
    }
    if (file.length > 5) {
      toast.error("You can only select up to 5 files at once");
      event.target.value = "";
      return;
    }
    // const formData = new FormData();
    // formData.append("file", file[0]);
    const formData = new FormData();
    for (let i = 0; i < file.length; i++) {
      formData.append("file[]", file[i]);
    }
    setIsLoading(true);
    setDocumentUploading(true);

    fetch(process.env.REACT_APP_API_URL + "/api/FileUploadmultiple", {
      method: "POST",
      body: formData,
    })
      .then((d) => d.json())
      .then((res) => {
        const fomrattedData = res?.map((each, index) => {
          return {
            id: index + 1,
            path: each.path,
            url: each.url,
            name: each.name,
            file_size: each?.size,
            file_type: each?.type,
          };
        });

        setDocuments(fomrattedData);
        setIsLoading(false);
        setDocumentUploading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setDocumentUploading(false);
        toast.error(
          "Upload failed due to server error. Please try again later"
        );
        console.log(error);
      });
  };

  const getAttachmentPath = (fileType) => {
    let imgPath = "";
    switch (fileType) {
      case "pdf":
        imgPath = "/svg/pdf-icon.svg";
        break;
      case "jpg":
        imgPath = "/svg/jpg-icon.png";
        break;
      case "jpeg":
        imgPath = "/svg/jpg-icon.png";
        break;
      case "xls":
        imgPath = "/svg/xls-icon.svg";
        break;
      case "xlsx":
        imgPath = "/svg/xls-icon.svg";
        break;
      case "png":
        imgPath = "/svg/png-icon.png";
        break;
      case "svg":
        imgPath = "/svg/svg-icon.svg";
        break;
      default:
        imgPath = "/svg/document-icon.svg";
        break;
    }
    return imgPath;
  };

  const removeUploadedAttachment = (id) => {
    const filteredAttachments = documents.filter((each) => each?.id != id);
    setDocuments(filteredAttachments);
  };

  const viewFile = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const submitLog = () => {
    if (documents.length || comment) {
      toast.dismiss();
      const attachmentsDetails = documents.map((document) => {
        return {
          unique: "uniqueAttachment",
          path: document?.path,
          url: document?.url,
          name: document.name,
          file_size: document?.file_size,
          file_type: document?.file_type,
        };
      });
      setDocumentUploading(true);
      setIsLoading(true);
      fetch(
        process.env.REACT_APP_API_URL + "/api/vendorpo/storeVendorBillsLogs",
        {
          method: "POST",
          body: JSON.stringify({
            ref_id: detailId.toString(),
            community_id: communityId,
            user_id: loadData("vendorId"),
            note_desc: comment,
            uploadedObjData: attachmentsDetails,
            is_actual_bill: isNormalBill ? 1 : -1,
          }),
          headers: { "content-type": "application/json" },
        }
      )
        .then((response) => response.json())
        .then((result) => {
          setDocumentUploading(false);
          setIsLoading(false);
          if (result?.status) {
            getVendorBillLogs();
            setDocuments([]);
            setComment("");
            toast.success(result?.message);
          } else {
            toast.error(result?.message);
          }
        })
        .catch((err) => {
          setDocumentUploading(false);
          setIsLoading(false);
          console.log(err);
        });
    }
  };

  useEffect(() => {
    if (showMessages && logsRef.current) {
      logsRef.current.scrollTo({
        top: logsRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [showMessages, billLogs]);

  let billStatus = "";
  if (isNormalBill) {
    const amountWithoutCommas = detail.gross_amount?.replace(/,/g, "");
    const parsedBillBalancedue = Number(detail.bill_ballance_due);
    const parsedBillAmount = Number(amountWithoutCommas);

    if (parsedBillBalancedue == 0) {
      billStatus = "paid";
    } else if (parsedBillBalancedue < parsedBillAmount) {
      billStatus = "partially paid";
    } else {
      billStatus = detail?.bill_approval_status;
    }
  } else {
    billStatus = detail?.bill_status;
  }

  return (
    <div>
      {initialLoading ? (
        <div className={styles.loaderwrapper}>
          <div className="noDataToShowList">
            <i
              className="fa fa-spinner fa-spin "
              style={{ color: "var(--BaseDarkColor)", fontSize: "40px" }}
            ></i>
          </div>
        </div>
      ) : (
        <>
          <div className={detail && styles.topDivPODetails}>
            <span>
              <h1>{detail && detail?.po_title?.toUpperCase()}</h1>
              <p>{detail && detail?.comunity_name}</p>
            </span>
            {detail.bill_migrated != "1" && (
              <div className={styles.iconsMainWrapper}>
                <StatusBadge
                  status={billStatus}
                  actualBillid={detail?.actual_bill_id}
                />
                {!detail?.actual_bill_id &&
                  detail?.bill_status?.toLowerCase() == "modify" && (
                    <CustomButton
                      onClick={() => {
                        setShowMessages(!showMessages);
                        if (!showMessages) {
                          getVendorBillLogs();
                        }
                      }}
                    >
                      Resubmit
                    </CustomButton>
                  )}

                {detail && (
                  <Tooltip
                    content={
                      <Paragraph className={styles.tooltip}>Chat</Paragraph>
                    }
                    appearance="card"
                    position="top"
                    className={styles.customTooltip}
                  >
                    <div
                      className={styles.actionIconMain}
                      onClick={() => {
                        setShowMessages(!showMessages);
                        if (!showMessages) {
                          getVendorBillLogs();
                        }
                      }}
                    >
                      <img src={IMAGE_PATH + "chat-icon.svg"} alt="" />
                    </div>
                  </Tooltip>
                )}

                {!detail?.actual_bill_id &&
                  detail?.bill_status?.toLowerCase() == "modify" && (
                    <Tooltip
                      content={
                        <Paragraph className={styles.tooltip}>Edit</Paragraph>
                      }
                      appearance="card"
                      position="top"
                      className={styles.customTooltip}
                    >
                      <div
                        className={styles.actionIconMain}
                        onClick={() => {
                          navigate("/createbill", {
                            state: {
                              hide: false,
                              billId: detail?.bill_id,
                              commId: detail?.community_id,
                            },
                          });
                        }}
                      >
                        <img src={IMAGE_PATH + "edit_icon.svg"} alt="" />
                      </div>
                    </Tooltip>
                  )}

                {detail?.bill_status?.toLowerCase() == "created" && (
                  <Tooltip
                    content={
                      <Paragraph className={styles.tooltip}>Delete</Paragraph>
                    }
                    appearance="card"
                    position="top"
                    className={styles.customTooltip}
                  >
                    <div
                      className={styles.actionIconMain}
                      onClick={() => setOpenDeleteModal(true)}
                    >
                      <img src={IMAGE_PATH + "delete_icon.svg"} alt="" />
                    </div>
                  </Tooltip>
                )}
              </div>
            )}
          </div>
          {showMessages ? (
            <div className={styles.messagesMainWrapper}>
              <div className={styles.messagesWrapper} ref={logsRef}>
                {billLogs?.map((each) => {
                  if (each.note_by != vendorId) {
                    return (
                      <div className={styles.adminWrapper}>
                        <div className={styles.name}>{each.created_by}</div>
                        <div className={styles.comment}>
                          <BillNotification message={each.note_desc} />
                        </div>
                        {each?.documents_arr?.map((document) => {
                          const fileType = document?.orig_name?.split(".")?.[1];
                          const imgPath = getAttachmentPath(fileType);
                          return (
                            <div
                              className={styles.attachmentWrapper}
                              onClick={() =>
                                viewFile(document?.file_download_url)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={imgPath}
                                alt=""
                                style={{ height: "36px", width: "36px" }}
                              />
                              <div>
                                <div className={styles.attachmentTitle}>
                                  {document?.orig_name}
                                </div>
                                <div className={styles.attachmentSize}>
                                  {bytesToKB(document?.file_size)}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                        <div className={styles.time}>{each.note_on}</div>
                      </div>
                    );
                  } else {
                    return (
                      <div className={styles.vendorWrapper}>
                        <div className={styles.name}>{each.created_by}</div>
                        <div className={styles.comment}>
                          <BillNotification message={each.note_desc} />
                        </div>
                        {each?.documents_arr?.map((document) => {
                          const fileType = document?.orig_name?.split(".")?.[1];
                          const imgPath = getAttachmentPath(fileType);
                          return (
                            <div
                              className={styles.attachmentWrapper}
                              onClick={() =>
                                viewFile(document?.file_download_url)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={imgPath}
                                alt=""
                                style={{ height: "36px", width: "36px" }}
                              />
                              <div>
                                <div className={styles.attachmentTitle}>
                                  {document?.orig_name}
                                </div>
                                <div className={styles.attachmentSize}>
                                  {bytesToKB(document?.file_size)}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                        <div className={styles.time}>{each.note_on}</div>
                      </div>
                    );
                  }
                })}
              </div>
              <div className={styles.inputWrapper}>
                <button
                  className={styles.iconWrapper}
                  onClick={handleIconClick}
                  disabled={documentUploading || isLoading}
                  style={{
                    opacity: documentUploading || isLoading ? 0.3 : 1,
                  }}
                >
                  <img src={IMAGE_PATH + "attachment-icon.svg"} alt="" />
                </button>
                <input
                  type="file"
                  ref={filePickerRef}
                  onChange={handleFileChange}
                  accept=".pdf, .jpg, .png, .jpeg, .xlsx, .xls"
                  multiple={true}
                  style={{ display: "none" }}
                />
                <TextInput
                  height={30}
                  className={styles.messageInput}
                  placeholder="Add your comment"
                  name="commnet"
                  value={comment}
                  onChange={(e) => {
                    setComment(e.target.value);
                  }}
                  required
                />
                <button
                  className={styles.iconWrapper}
                  onClick={submitLog}
                  disabled={documentUploading || isLoading}
                  style={{
                    opacity: documentUploading || isLoading ? 0.3 : 1,
                  }}
                >
                  <img src={IMAGE_PATH + "send-icon.svg"} alt="" />
                </button>
              </div>
              <div className={styles.attachmentWrapperUploadedMain}>
                {documents?.map((document) => {
                  const fileType = document?.name?.split(".")?.[1];
                  const imgPath = getAttachmentPath(fileType);

                  return (
                    <div className={styles.attachmentWrapperUploaded}>
                      <img
                        src={imgPath}
                        alt=""
                        style={{ height: "36px", width: "36px" }}
                      />
                      <div>
                        <div className={styles.attachmentTitle}>
                          {document?.name}
                        </div>
                        <div className={styles.attachmentSize}>
                          {bytesToKB(document?.file_size)}
                        </div>
                      </div>
                      <spna
                        className={styles.removeIcon}
                        onClick={() => removeUploadedAttachment(document?.id)}
                      >
                        ✕
                      </spna>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <>
              <ModalComp
                open={open}
                onOpenModal={onOpenModal}
                onCloseModal={onCloseModal}
                detail={detail}
              />
              <div className={styles.middleDivPODetails}>
                {detail ? (
                  <>
                    <BillsPaymentDetailCard {...detail} />
                    <PurchaseOrderTable
                      tableData={detail?.vendor_bill_items}
                      total={total}
                      billId={detail?.bill_id}
                      poId={detail?.po_id}
                    />
                    <BillsNotes {...detail} />
                    <BillsAttachments {...detail} />
                  </>
                ) : (
                  <div className="noDataToShow">
                    <img src={IMAGE_PATH + "billsDetails.svg"} alt="" />
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}
      <CustomDeleteConfirmationModal
        isOpen={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        onConfirm={() => {
          deleteBill({
            community_id: detail?.community_id,
            bill_id: detail?.bill_id,
            vendor_id: detail?.vendor_id,
          });
        }}
        title="Delete Bill"
        message="Are you sure you want to delete this bill?"
        itemName={detail?.bill_number}
        isDeleting={isDeleting}
        confirmButtonText="Delete Bill"
        cancelButtonText="Cancel"
      />
    </div>
  );
};
